<template>
  <boxwrap class="window-details--inner">
    <boxwrap-header>
      <boxwrap-header-items class="window-detail-title">
        <i class="ico--message"></i>
        <span>message from {{message.admin}}</span>
      </boxwrap-header-items>

      <boxwrap-header-items class="date-info">
        <div class="date-info--inner">
          <div class="date-info-items">
            <span class="date-info-lbl">created date</span>
            <span class="date-info-date">{{message.created_at | date}}</span>
          </div>

          <div class="date-info-items">
            <span class="date-info-lbl">deleted date</span>
            <span class="date-info-date">{{message.deleted_at | date}}</span>
          </div>

          <div class="date-info-items">
            <span class="date-info-lbl">send type</span>
            <span class="date-info-date">{{message.condition}}</span>
          </div>
        </div>
      </boxwrap-header-items>
    </boxwrap-header>
    <boxwrap-contents>
      <div class="message-detail">
        <div class="message-detail__item">
          <div class="message-detail-con">
            <div class="message-detail-title">
              <span class="-lbl">title</span>
              <div class="textarea-wrap">
                <quill-editor
                  ref="title"
                  :options="quillTitleConfig"
                  v-model="message.title"
                >
                </quill-editor>
              </div>
            </div>
            <div class="message-detail-content">
              <span class="-lbl">content</span>
              <div class="textarea-wrap">
                <quill-editor
                  ref="content"
                  :options="quillContentConfig"
                  v-model="message.content"
                >
                </quill-editor>
              </div>
            </div>
            <button
              class="btn--modify -withlabel"
              @click="modify"
            >
              <i class="ico--save"></i>
              <span>Modify</span>
            </button>
          </div>
        </div>
        <div class="message-detail__item">
          <div class="message-recipient">
            <div class="message-recipient__item">
              <div class="message-recipient--head">
                <span>recipient: {{message.recipientCount}}</span>
                <div class="message-recipient-toolbar">
                  <div class="message-recipient-toolbar__item">

                  </div>
                  <select-list
                    v-model="recipientParams.filter_by"
                  >
                    <select-option
                      name="login id"
                      value="login_id"
                    >
                    <span>login id</span>
                    </select-option>
                    <select-option
                      name="login name"
                      value="login_name"
                    >
                    <span>login name</span>
                    </select-option>
                  </select-list>
                  <div class="searchbar">
                    <div class="input-wrap">
                      <input
                        placeholder="search id / name"
                        v-model="recipientParams.q"
                        @keyup.enter="search('recipients')"
                      >
                    </div>
                    <button
                      class="btn--clear"
                      @click="removeFilter('recipients')"
                    >
                      <i class="ico--clear"></i>
                    </button>
                  </div>
                </div>
              </div>

              <check-data-list
                label="loading"
                v-if="isDataLoadingRecipient || isEmptyRecipient"
                :isLoading="isDataLoadingRecipient"
                :isEmpty="isEmptyRecipient"
              >
              </check-data-list>
              <tbl
                :scrollable="true"
                :dataLoading="isDataLoadingRecipient"
              >
                <tbl-inner v-if="!isDataLoadingRecipient">
                  <tbl-head>
                    <tbl-row
                    >
                      <tbl-td name="login_id">
                        login id
                      </tbl-td>

                      <tbl-td name="login_name">
                        login name
                      </tbl-td>

                      <tbl-td name="level">
                        level
                      </tbl-td>

                      <tbl-td name="agent">
                        agent
                      </tbl-td>
                    </tbl-row>
                  </tbl-head> <!-- tbl-head-->

                  <tbl-body>
                    <tbl-row
                      v-for="recipient in message.recipient"
                      :key="recipient.id"
                    >
                    <tbl-td name="login_id">
                      {{recipient.login_id}}
                    </tbl-td>

                    <tbl-td name="login_name">
                      {{recipient.login_name}}
                    </tbl-td>

                    <tbl-td name="level">
                      {{recipient.level}}
                    </tbl-td>

                    <tbl-td name="agent">
                      {{recipient.agent}}
                    </tbl-td>
                    </tbl-row>
                  </tbl-body> <!--tbl-body-->
                </tbl-inner>

                <tbl-footer>
                  <pagination
                    :total="recipientTotal"
                    :limit="recipientParams.rows"
                    :rows="recipientParams.rows"
                    v-model="recipientParams.page"
                    @page="search('recipients')"
                  ></pagination>
                </tbl-footer>
              </tbl>
            </div>
            <div class="message-recipient__item">
              <div class="message-recipient--head">
                <span>Readers: {{message.readersCount}}</span>
                <div class="message-recipient-toolbar">
                  <div class="message-recipient-toolbar__item">

                  </div>
                  <select-list
                    v-model="readerParams.filter_by"
                  >
                    <select-option
                      name="login id"
                      value="login_id"
                    >
                    <span>login id</span>
                    </select-option>
                    <select-option
                      name="login name"
                      value="login_name"
                    >
                    <span>login name</span>
                    </select-option>
                  </select-list>
                  <div class="searchbar">
                    <div class="input-wrap">
                      <input
                        placeholder="search id / name"
                        v-model="readerParams.q"
                        @keyup.enter="search('readers')"
                      >
                    </div>
                    <button
                      class="btn--clear"
                      @click="removeFilter('readers')"
                    >
                      <i class="ico--clear"></i>
                    </button>
                  </div>
                </div>
              </div>
              <check-data-list
                label="loading"
                v-if="isDataLoadingReader || isEmptyReader"
                :isLoading="isDataLoadingReader"
                :isEmpty="isEmptyReader"
              >
              </check-data-list>
              <tbl
                :scrollable="true"
                :dataLoading="isDataLoadingReader"
              >
                <tbl-inner v-if="!isDataLoadingReader">
                  <tbl-head>
                    <tbl-row
                    >
                      <tbl-td name="login_id">
                        login id
                      </tbl-td>

                      <tbl-td name="login_name">
                        login name
                      </tbl-td>

                      <tbl-td name="level">
                        level
                      </tbl-td>

                      <tbl-td name="agent">
                        agent
                      </tbl-td>

                      <tbl-td name="read_at">
                        read at
                      </tbl-td>

                      <tbl-td name="deleted_at">
                        deleted at
                      </tbl-td>
                    </tbl-row>
                  </tbl-head> <!-- tbl-head-->

                  <tbl-body>
                    <tbl-row
                      v-for="reader in message.readers"
                      :key="reader.id"
                    >
                    <tbl-td name="login_id">
                      {{reader.login_id}}
                    </tbl-td>

                    <tbl-td name="login_name">
                      {{reader.login_name}}
                    </tbl-td>

                    <tbl-td name="level">
                      {{reader.level}}
                    </tbl-td>

                    <tbl-td name="agent">
                      {{reader.agent}}
                    </tbl-td>

                    <tbl-td name="read_at">
                      {{reader.read | date}}
                    </tbl-td>

                    <tbl-td name="deleted_at">
                      {{reader.deleted | date}}
                    </tbl-td>
                    </tbl-row>
                  </tbl-body> <!--tbl-body-->
                </tbl-inner>

                <tbl-footer>
                  <pagination
                    :total="readerTotal"
                    :limit="readerParams.rows"
                    :rows="readerParams.rows"
                    v-model="readerParams.page"
                    @page="search('readers')"
                  ></pagination>
                </tbl-footer>

              </tbl>
            </div>
          </div>
        </div>

      </div>
    </boxwrap-contents>
  </boxwrap>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import _ from 'lodash'
//= components
import Pagination from '@/components/base/Pagination'
import TextArea from '@/components/base/TextArea'
import CheckDataList from '@/components/base/CheckDataList'
import { quillEditor } from 'vue-quill-editor'

import { swal } from '@/assets/js/mixins/base/Swal'

import '@/components/layout/boxwrap/Boxwrap'
import '@/components/base/select/Select'

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

export default {
  name: 'support-messages-details-page',

  components: {
    Pagination,
    TextArea,
    CheckDataList,
    'quill-editor': quillEditor
  },

  mixins: [ swal ],

  data () {
    return {
      recipientParams: {
        page: 1,
        rows: 10,
        filter_by: '',
        q: '',
        sort_by: 'id',
        sort: 'desc',
        date_from: '',
        date_to: ''
      },

      readerParams: {
        page: 1,
        rows: 10,
        filter_by: '',
        q: '',
        sort_by: 'id',
        sort: 'desc',
        date_from: '',
        date_to: ''
      },

      message: {},

      // flags
      isDataLoadingRecipient: true,
      showDataLoadingRecipient: false,
      isEmptyRecipient: false,

      isDataLoadingReader: true,
      showDataLoadingReader: false,
      isEmptyReader: false,

      recipientCount: 0,
      readerCount: 0,

      filterBy: [
        {
          value: 'login_id',
          display: 'id'
        },

        {
          value: 'login_name',
          display: 'name'
        }
      ],

      quillTitleConfig: {
        placeholder: 'Title here...',
        modules: {
          toolbar: [
            [{ 'align': [] }],
            ['bold', 'italic', 'underline', 'strike'],
            [
              { 'list': 'ordered' },
              { 'list': 'bullet' }
            ],
            [
              { 'indent': '-1' },
              { 'indent': '+1' }
            ],
            [
              { 'direction': 'rtl' }
            ],
            [
              { 'color': [] },
              { 'background': [] }
            ]
          ]
        }
      },

      quillContentConfig: {
        placeholder: 'Content here...',
        modules: {
          toolbar: [
            [{ 'align': [] }],
            ['bold', 'italic', 'underline', 'strike'],
            [
              { 'list': 'ordered' },
              { 'list': 'bullet' }
            ],
            [
              { 'indent': '-1' },
              { 'indent': '+1' }
            ],
            [
              { 'direction': 'rtl' }
            ],
            [
              { 'color': [] },
              { 'background': [] }
            ]
          ]
        }
      }
    }
  },

  computed: {
    ...mapState('support', { m: 'messages' }),

    checkPermission () {
      let permission = JSON.parse(window.localStorage.permission)
      let dbKey = this.$route.meta.dbKey
      let obj

      for (let key in permission) {
        if (dbKey === key) {
          obj = permission[key]
        }
      }

      return obj === 'rw' ? 1 : ''
    },

    recipientTotal () {
      return this.recipientCount > 0 ? this.recipientCount : this.message.recipientCount || 0
    },

    readerTotal () {
      return this.readerCount > 0 ? this.readerCount : this.message.readersCount || 0
    }
  },

  async created () {
    let result = await this.getMessage({ id: this.$route.params.id })
    this.message = Object.assign({}, result.data[0])

    this.isDataLoadingReader = false
    this.showDataLoadingReader = false
    this.isDataLoadingRecipient = false
    this.showDataLoadingRecipient = false
    if (!this.message.length) {
      this.isEmptyReader = false
      this.isEmptyRecipient = false
    }
  },

  methods: {
    ...mapActions('support', { getMessage: 'get' }),
    ...mapActions('support', [ 'getRecipients', 'getReaders', 'updateMessages' ]),

    async search (flag) {
      let id = this.$route.params.id
      let result

      this.isEmpty = false

      if (!this.showDataLoading) {
        this.isDataLoading = true
      }

      if (flag === 'recipients') {
        result = await this.getRecipients({
          msgId: id,
          params: this.recipientParams
        })

        this.message.recipient = result.data.users
        this.recipientCount = result.data.total

        this.isDataLoadingRecipient = false
        this.showDataLoadingRecipient = false
        if (!this.message.recipient.length) {
          this.isEmptyRecipient = true
        }
      }

      if (flag === 'readers') {
        result = await this.getReaders({
          msgId: id,
          params: this.readerParams
        })

        this.message.readers = result.data.users
        this.readerCount = result.data.total

        this.isDataLoadingReader = false
        this.showDataLoadingReader = false
        if (!this.message.readers.length) {
          this.isEmptyReader = true
        }
      }
    },

    async modify () {
      let success = async () => {
        let result = await this.updateMessages({
          id: this.$route.params.id,
          title: this.message.title,
          content: this.message.content
        })

        if (result.status === 204) {
          this.$alert('success', 'You have successfully modified message(s).', {}, '', 'Success')
        }
      }

      if (this.message.title === '' || this.message.content === '') {
        this.$alert('error', 'Missing title or content data.', {}, '', 'Error')
        return
      }

      if (this.message.title.replace(/(<([^>]+)>)/ig, ' ').trim() === '' ||
          this.message.content.replace(/(<([^>]+)>)/ig, ' ').trim() === '') {
        this.$alert('error', 'Missing title or content data.', {}, '', 'Error')
        return
      }

      this.$alert('prompt', 'Are you sure you want to modify the following message(s)?',
        {}, { success }, 'Modify Message')
    },

    removeFilter (flag) {
      if (flag === 'recipients') {
        this.recipientParams.filter_by = ''
        this.recipientParams.q = ''
      }

      if (flag === 'readers') {
        this.readerParams.filter_by = ''
        this.readerParams.q = ''
      }

      this.search(flag)
    }
  }
}
</script>
